import './online-booking-page.css';
import { AudioOutlined } from '@ant-design/icons';
import { strings } from '../../../lang';
import { CaseInfo } from '../../../dto/model';

type OnlineRecordingBookingPageProps = {
  caseInfo: CaseInfo | null;
  isAgentOnline: boolean;
  isUserRecorded: boolean;
  isRecording: boolean;
};

export const OnlineRecordingBookingPage = ({ isAgentOnline, isUserRecorded, isRecording }: OnlineRecordingBookingPageProps) => {
  // Show the indicator only while audio is actually being captured, so it disappears as soon as
  // recording stops (e.g. the case is closed/booked) even though the agent is still online.
  const show = isUserRecorded && isAgentOnline && isRecording;

  return (
    <div className={`bp-section-recording ${show ? '' : 'bp-section-recording-hidden'}`}>
      <AudioOutlined className={`bp-microphone-${show ? 'green' : 'black'}`} />
      <span className="bp-recording-text">{show ? strings.recordingInProgress : ''}</span>
    </div>
  );
};
